module.exports = __webpack_public_path__ + "img/2@2x.b69dffea.png";